export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10631.d4d17c22.jpg";